import React from 'react';
// import {
// 	Route,
// 	Link
// } from 'react-router-dom';
import './resources.scss';
import { Carousel } from 'antd';
// import ajax from '@/api/public';

class Resource extends React.Component{
	constructor (props) {
		super(props)
		this.state={

		}
	}
	componentDidMount (){
        document.getElementById('app').scrollIntoView(true)
	}
	render() {
		return(
			<div className="resource-child">
			<div className='weidai'>
				<div className='common-head home-contain'>
					<a href='#/resource' className="mianbaoxie">流量资源</a> <i className='glyphicon glyphicon-toright'></i> <span>互动广告</span>
				</div>
				<div className='common-title minWith' style={{marginBottom: '24px'}}>什么是互动广告？</div>
				<div className='text-center minWith'>在特定媒介或载体上针对产品需要传达的信息主题，借助创新的互动形式进行的广告推广。</div>
				<div className='text-title text-center minWith'>您的广告可以展示在这里</div>
				<div className='home-contain' style={{paddingBottom: '50px'}}>
					<div className='home-contain text-contain'>
						<span className='second-title'></span>
						<div className='text-center'>
							<div>
								<div className='mobile-border' style={{display: 'inline-block', position: 'relative'}}>
									<img src={`${process.env.PUBLIC_URL}/images/mobile-border2.png`} style={{position: 'absolute', left: '0', top: '0'}}/>
									<img src={`${process.env.PUBLIC_URL}/images/hd1.png`} style={{position: 'absolute', left: '11px', top: '25px'}}/>
								</div>
								<div className='mobile-border' style={{display: 'inline-block', position: 'relative', marginLeft: '115px'}}>
									<img src={`${process.env.PUBLIC_URL}/images/mobile-border2.png`} style={{position: 'absolute', left: '0', top: '0'}}/>
									<img src={`${process.env.PUBLIC_URL}/images/hd2.png`} style={{position: 'absolute', left: '11px', top: '25px'}}/>
								</div>
							</div>
						</div>
						<div className='text-center' style={{marginTop: '36px'}}>
							<div>
								<div className='mobile-border' style={{display: 'inline-block', position: 'relative'}}>
									<img src={`${process.env.PUBLIC_URL}/images/mobile-border2.png`} style={{position: 'absolute', left: '0', top: '0'}}/>
									<img src={`${process.env.PUBLIC_URL}/images/hd3.png`} style={{position: 'absolute', left: '11px', top: '25px'}}/>
								</div>
								<div className='mobile-border' style={{display: 'inline-block', position: 'relative', marginLeft: '115px'}}>
									<img src={`${process.env.PUBLIC_URL}/images/mobile-border2.png`} style={{position: 'absolute', left: '0', top: '0'}}/>
									<img src={`${process.env.PUBLIC_URL}/images/hd4.png`} style={{position: 'absolute', left: '11px', top: '25px'}}/>
								</div>
							</div>
						</div>
					</div>
				</div>
			</div>
			</div>
		)
	}
}
export default Resource;



// WEBPACK FOOTER //
// ./src/components/resources/hdbanner.jsx